import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from '@/utils/mixin.js';
export default {
  name: "Footer",
  mixins: [mixinDevice],
  data: function data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
      menus: [],
      isLogin: false
    };
  },
  created: function created() {
    this.tenantInfo = this.$store.getters.tenantInfo;
    this.isLogin = this.$store.getters.userInfo != null;
    this.menus = this.$store.getters.menuList;
    console.log(this.menus);
  }
};